import { GetProfileDetailsDto, GetProfileDetailsDtoImpl } from './getprofiledetailsdto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class GetProfileDetailsBuilder {
    constructor(private profileDetails: any)
    {
        if(profileDetails === undefined)
        {
            throw new NoDataException("Get Profile data doesnt exists");
        }
    }

    buildAll(): GetProfileDetailsDto {
        return this.parseGetProfileDetailsResponse();
    }

    private parseGetProfileDetailsResponse(): GetProfileDetailsDto 
    {
        
       
        let getProfileDetailsResponse = new GetProfileDetailsDtoImpl();
        getProfileDetailsResponse.setUserName(this.profileDetails.userName);
        getProfileDetailsResponse.setProfilePicturePath(this.profileDetails.profilePicturePath);
        getProfileDetailsResponse.setMsisdn(this.profileDetails.msisdn);
        getProfileDetailsResponse.setEmailId(this.profileDetails.emailId);
        getProfileDetailsResponse.setClientTxnId(this.profileDetails.clientTxnId);
        getProfileDetailsResponse.setRespDesc(this.profileDetails.respDesc);
        getProfileDetailsResponse.setDob(this.profileDetails.dob);

        let categories: string[] = [];

        this.profileDetails.categories.split(",").forEach((id: string) =>
        {
            categories.push(id);
        });

        getProfileDetailsResponse.setCategories(categories);

        return getProfileDetailsResponse;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getprofile/getprofiledetailsbuilder.ts